export enum SkeletonShapeEnum {
  RECTANGLE = "rectangle",
  TEXT = "text",
  CIRCLE = "circle",
}
